import { render, staticRenderFns } from "./sexPieChart.vue?vue&type=template&id=43bf5f2d&"
import script from "./sexPieChart.vue?vue&type=script&lang=js&"
export * from "./sexPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports